import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import { OrganizationUserService, OrganizationUserResetPasswordVM } from "@propertelligent/client-api";
import RightSideModal from "../../../newComponents/Modal/right-side-modal";
import InputField from "../../../newComponents/form-fields/InputField";
import Card from "../../../newComponents/card";
import apiHelper from "../../../utils/apiHelper";

interface ResetPasswordProps {
  isOpen: boolean;
  onClose: () => void;
  userId: number; // Added userId to props
}

const ResetPasswordModal: React.FC<ResetPasswordProps> = ({ isOpen, onClose, userId }) => {
  const methods = useForm<OrganizationUserResetPasswordVM>({
    mode: "onChange",
    defaultValues: {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "", // Matches the VM type
    },
  });

  const { watch, formState: { isDirty, isValid } } = methods;
  const newPassword = watch("newPassword");

  const onSubmit = async (data: OrganizationUserResetPasswordVM) => {
    // Calling the provided API method
    const res = await apiHelper(
      OrganizationUserService.putApiOrganizationUserResetPassword,
      { title: "Password Reset Successful", showNotification: true, successMessage: "Password has been reset successfully." },
      userId,
      data
    );

    if (res?.data) {
      onClose();
    }
  };

  return (
    <RightSideModal
      isOpen={isOpen}
      onClose={onClose}
      title="Reset Password"
      buttonlabel="Save"
      formId="reset-password-form"
      isDirty={isDirty}
      isLoading={methods.formState.isSubmitting}
      isSubmitDisabled={methods.formState.isSubmitting || !isDirty || !isValid}
    >
      <Card className="no-bg">
        <FormProvider {...methods}>
          <form id="reset-password-form" onSubmit={methods.handleSubmit(onSubmit)}>
            <div className="row g-3">
              {/* Current Password */}
              <div className="col-md-12">
                <InputField
                  name="currentPassword"
                  label="Current Password"
                  type="password"
                  required
                  requiredMessage="Current password is required"
                  placeholder="********"
                  allowSpecialChars
                />
              </div>

              {/* New Password */}
              <div className="col-md-6">
                <InputField
                  name="newPassword"
                  label="New Password"
                  type="password"
                  required
                  requiredMessage="New password is required"
                  placeholder="********"
                  allowSpecialChars
                />
              </div>

              {/* Confirm Password - Name updated to match VM */}
              <div className="col-md-6">
                <InputField
                  name="confirmNewPassword"
                  label="Confirm New Password"
                  type="password"
                  required
                  requiredMessage="Confirm new password is required"
                  placeholder="********"
                  allowSpecialChars
                />
              </div>
            </div>
          </form>
        </FormProvider>
      </Card>
    </RightSideModal>
  );
};

export default ResetPasswordModal;